import { translate } from '@/ui/i18n';

export const seasonDurationIsMaximumOneYear = (
  date: string,
  startDate: string,
) => {
  const startD = new Date(startDate).setHours(0, 0, 0, 0);
  const startDYear = new Date(startD).getFullYear();
  const startDPlusOneYear = new Date(startD).setFullYear(startDYear + 1);
  const endD = new Date(date).setHours(0, 0, 0, 0);

  return (
    !startDate ||
    endD <= startDPlusOneYear ||
    translate('ProjectsVenue.Form.season-duration-is-maximum-one-year')
  );
};
